// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu8 = () => {
    const { menuDashboard8 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard8?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard8.id,
        title: <FormattedMessage id={`${menuDashboard8.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard8.icon],
        type: menuDashboard8.type,
        children: ChildrenList
    };

    return dashboardList;
};
